function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
export { _setPrototypeOf as default };


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 827
// module chunks = 1